import http from "../helpers/httpCommon";

class GroupService {
    create(data) {
        return http().post("/collagesCreate", data);
    }

    read(data) {
        return http().post("/collagesRead", data);
    }

    update(data) {
        return http().post(`/collagesUpdate`, data);
    }

    delete(data) {
        return http().post(`/collagesDelete`, data);
    }

    list(data) {
        return http().post("/collagesList", data)
    }
}

export default new GroupService();
